import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { WaitlistForm } from "./WaitlistForm";

// Add entries like { label: "Facebook", href: "https://..." } to show the Follow column.
const SOCIAL_LINKS = [];

export const Footer = () => (
  <footer className="bg-navy text-slate-300" data-testid="site-footer">
    <div className="container-x py-16 sm:py-20">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Logo light />
          <p className="mt-6 max-w-sm font-display text-2xl italic leading-snug text-white">Faithful stewardship, carefully recorded.</p>
        </div>
        <div className="lg:col-span-7">
          <p className="eyebrow-light">Join the waitlist</p>
          <p className="mb-5 mt-2 text-sm text-slate-300">Hear launch pricing first.</p>
          <WaitlistForm id="footer-waitlist" dark source="footer" />
        </div>
      </div>
      <div className={`mt-16 grid gap-10 border-t border-white/10 pt-10 ${SOCIAL_LINKS.length ? "sm:grid-cols-3" : "sm:grid-cols-2 lg:grid-cols-3"}`}>
        <div>
          <p className="eyebrow-light">Site</p>
          <ul className="mt-4 space-y-2 text-sm">
            {[["/features", "Features"], ["/pricing", "Pricing"], ["/demo", "Request a demo"]].map(([to, l]) => (
              <li key={to}><Link to={to} className="transition-colors hover:text-white" data-testid={`footer-link-${l.toLowerCase().replace(/ /g, "-")}`}>{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <p className="eyebrow-light">Contact</p>
          <ul className="mt-4 space-y-2 text-sm" data-testid="footer-contact">
            <li><a href="mailto:info@gracetreasury.app" className="transition-colors hover:text-white" data-testid="footer-email-link">info@gracetreasury.app</a></li>
            <li className="leading-relaxed" data-testid="footer-address">Grace Treasury<br />1904 Johns Creek Rd.<br />Milton, WV 25541</li>
          </ul>
        </div>
        {SOCIAL_LINKS.length > 0 && (
          <div>
            <p className="eyebrow-light">Follow</p>
            <ul className="mt-4 space-y-2 text-sm">
              {SOCIAL_LINKS.map((s) => (
                <li key={s.href}><a href={s.href} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-white" data-testid={`footer-social-${s.label.toLowerCase()}`}>{s.label}</a></li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <p className="mt-14 text-xs text-slate-400">&copy; {new Date().getFullYear()} Grace Treasury. All rights reserved.</p>
    </div>
  </footer>
);
